<div class="mat-typography">
  <div fxLayout="column" fxLayoutAlign="start center" >
    <ng-container *ngIf="resources">
      <div fxLayout="row wrap" fxFill>
        <gz-item-card class="item-card"
                      *ngFor="let res of resources"
                      fxFlex.xs="100%"
                      fxFlex.sm="50%"
                      fxFlex.md="25%"
                      [removable]=removable
                      [resource]=res
                      [type]="resourceType"
                      (removeClicked)="remove($event)">
        </gz-item-card>
      </div>

      <mat-paginator [length]="length"
                     [pageIndex]="pageIndex"
                     [pageSize]="pageSize"
                     [pageSizeOptions]="pageSizeOptions"
                     (page)="pageEvent($event)">
      </mat-paginator>
    </ng-container>

    <div class="loading-footer mat-typography">
      <div id="html-spinner" *ngIf="loading || !resources"></div>

      <h3 *ngIf="finished && resources && resources.length !== 0">
        No more {{resourceType}} to load.
      </h3>

      <h3 *ngIf="resources && resources.length === 0">
        No {{resourceType}} found.
      </h3>
    </div>
  </div>
</div>
